import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";

import { getEventById } from "../Feed/EventsTab/Hooks/data";

import EventDetails from "./Component/EventDetails";

import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import EventGallery from "@/Components/Media/Event/Layout/EventGallery";

type Props = {
  eventId: string;
};

function EventDetailsScreen({ eventId }: Props): React.JSX.Element {
  const event = getEventById(eventId);
  return (
    <ScreenLayout isLoading={false}>
      <View style={styles.container}>
        <ScrollView>
          {event.gallery.images.length > 0 && (
            <EventGallery gallery={event.gallery} />
          )}
          <EventDetails details={event} />
        </ScrollView>
      </View>
    </ScreenLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
});

export default EventDetailsScreen;
